import { getBackgroundCSS, getSpaceCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { verticalAlign, textAlign, background, minHeight, padding } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#psbParallaxSection-${clientId}{
			min-height: ${minHeight};
		}
		#psbParallaxSection-${clientId} .psbParallaxSection{
			justify-content: ${verticalAlign};
			text-align: ${textAlign};
			min-height: ${minHeight};
			padding: ${getSpaceCSS(padding)};
		}
		#psbParallaxSection-${clientId} .psbParallaxImg{
			${getBackgroundCSS(background)}
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;